import { EmailViewerV2 } from './email-viewer-v2';
import { EmailThreadViewer } from './EmailThreadViewer';
import { EmailViewerProps } from './email-viewer-types';

export interface SmartEmailViewerProps extends EmailViewerProps {
  /**
   * Conversation ID for thread display
   * If provided, shows EmailThreadViewer
   */
  conversationId?: string | null;
  /** Document IDs to highlight (for showing source documents of invoices/POs) */
  highlightedDocumentIds?: string[];
  /** Email IDs to highlight */
  highlightedEmailIds?: string[];
  /** Source document ID (for invoices created from documents) */
  sourceDocumentId?: string;
  /** Source email ID (for invoices created from inbound email) */
  sourceEmailId?: string;
}

/**
 * Smart wrapper that renders EmailThreadViewer when a conversationId exists,
 * and falls back to EmailViewerV2 for single-email display.
 */
export function SmartEmailViewer({
  conversationId,
  emailData,
  fetchOCR,
  fetchExtractedPurchaseOrder,
  defaultTab = 'email',
  highlightedDocumentIds,
  highlightedEmailIds,
  sourceDocumentId,
  sourceEmailId,
  onRefreshData,
  splitDocuments,
  attachmentViewerHeight,
}: SmartEmailViewerProps) {
  const shouldShowThreadViewer =
    typeof conversationId === 'string' && conversationId.trim().length > 0;

  if (shouldShowThreadViewer) {
    return (
      <EmailThreadViewer
        conversationId={conversationId}
        fetchOCR={fetchOCR}
        fetchExtractedPurchaseOrder={fetchExtractedPurchaseOrder}
        highlightedDocumentIds={highlightedDocumentIds}
        highlightedEmailIds={highlightedEmailIds}
        sourceDocumentId={sourceDocumentId}
        sourceEmailId={sourceEmailId}
      />
    );
  }

  // Fallback to single email viewer
  return (
    <EmailViewerV2
      emailData={emailData}
      fetchOCR={fetchOCR}
      fetchExtractedPurchaseOrder={fetchExtractedPurchaseOrder}
      defaultTab={defaultTab}
      onRefreshData={onRefreshData}
      splitDocuments={splitDocuments}
      attachmentViewerHeight={attachmentViewerHeight}
    />
  );
}
